import * as $utils from 'utils';

export default {
  beforeMount(el, binding) {
    let resizeHandler = (entries) => binding.value(entries, el)
    resizeHandler = binding.arg ? $utils.timers.debounce(resizeHandler, ++binding.arg) : resizeHandler
    el.__resize_handler = (entries) => {
      el.__raf_id = requestAnimationFrame(() =>resizeHandler(entries))
    }
    el.__resize_observer = new ResizeObserver(el.__resize_handler)
    el.__resize_observer.observe(el)
  },
  mounted(el) {
    el.dispatchEvent(new Event('resize'))
  },
  beforeUnmount(el) {
    if (el.__raf_id) {
      cancelAnimationFrame(el.__raf_id)
    }
    el.__resize_handler.abort && el.__resize_handler.abort()
    el.__resize_observer.disconnect()
  }
}